import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Typography } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { login, isLoggedIn } from "../services/authService";
import styles from "./Login.module.css";
import { routes } from "../routes";
import { doctorsService } from "../services/doctorsService";
import { adminUserService } from "../services/adminUserService";
import { useAuth } from "../contexts/authContext";
import { useLoaderProvider } from "../contexts/LoaderContext";

const { Text } = Typography;

const getSafeRedirectPath = (redirect: string | null) => {
  if (!redirect || !redirect.startsWith("/") || redirect.startsWith("//")) {
    return routes.DASHBOARD;
  }

  return redirect;
};

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginContext } = useAuth();
  const { showLoader, hideLoader } = useLoaderProvider();
  const redirectPath = getSafeRedirectPath(
    new URLSearchParams(location.search).get("redirect")
  );

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (isLoggedIn()) {
        try {
          showLoader("Recupero informazioni account...");
          await adminUserService.getAccount();
          const doctor = await doctorsService.getLoggedDoctor();
          loginContext(doctor);
          navigate(redirectPath, { replace: true });
        } catch (error) {
          console.error(
            "Errore nel recupero delle informazioni dell'account:",
            error
          );
        } finally {
          hideLoader();
        }
      }
    };

    checkLoginStatus();
  }, [hideLoader, loginContext, navigate, redirectPath, showLoader]);

  const handleLogin = () => {
    login({ redirectUri: `${window.location.origin}${redirectPath}` });
  };

  return (
    <div className={styles.loginContainer}>
      <Card className={styles.loginCard} title="Accedi a Core Rare">
        <p style={{ textAlign: "center" }}>Benvenuto nella piattaforma</p>
        <div style={{ textAlign: "center" }}>
          <Text strong style={{ fontSize: "1.5rem" }}>
            Core Rare
          </Text>
        </div>
        <Button type="primary" icon={<LoginOutlined />} onClick={handleLogin}>
          Accedi
        </Button>
      </Card>
    </div>
  );
};

export default LoginPage;
